
export const EMAIL_REGEX = "^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$";

// Initialize log level from localStorage on module load
const STORAGE_KEY = 'xaLogLevel';
const storedLogLevel = localStorage.getItem(STORAGE_KEY);
if (storedLogLevel) {
  (window as any).xaLogLevel = storedLogLevel;
}

// Override the setter to persist to localStorage
Object.defineProperty(window, 'xaLogLevel', {
  get: function() {
    return this._xaLogLevel;
  },
  set: function(value) {
    this._xaLogLevel = value;
    if (value) {
      localStorage.setItem(STORAGE_KEY, value);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }
});

// Returns current timestamp
function getCurrentDateString() {
  return (new Date()).toISOString() + " ::";
}

type LogParam = unknown;

export function log(...args: readonly LogParam[]): void {
  if (window.xaLogLevel === "debug") {
    console.log(getCurrentDateString(), ...args);
  }
}

export function err(...args: readonly LogParam[]): void {
  console.error(getCurrentDateString(), ...args);
}

export const logOnce = (key: string, ...args: readonly LogParam[]): void => {
  const map = {};
  if (!map[key]) {
    map[key] = true;
    log(...args);
  }
}

// export type Noop = () => void;
// tslint:disable-next-line:no-empty
// export const noop: Noop = () => {};

export { default as insertSorted } from "./insertSorted";
export * from "./nick-utils";
// export * from "./PersistentStorage";
export * from "./useIsMounted";
export * from "./retryRequest"
export * from "./time";